// Copyright (c) 2016 Deere & Company

import busyCounter from '../../../shared/reducers/busy-counter';
import claim from './spa-claim';
import {combineReducers} from 'redux';
import confirmationModal from './confirmation-modal';
import createClaimModal from './create-claim-modal';
import customer from './customer';
import failureModes from './failure-modes';
import formValidation from './form-validation';
import isActionButtonDisabled from './is-action-button-disabled';
import isCopied from './is-copied';
import isEditable from './is-editable';
import isStickyHeaderVisible from './is-sticky-header-visible';
import isValidClaim from './is-valid-claim';
import product from './product-details';
import spaTypes from './spa-types';
import temporaryObjectKey from './temporary-object-key';
import warrantyStatusModal from './warranty-status-modal';

export const getCombinedReducers = () => combineReducers({
    busyCounter,
    claim,
    confirmationModal,
    createClaimModal,
    customer,
    failureModes,
    formValidation,
    isActionButtonDisabled,
    isCopied,
    isEditable,
    isStickyHeaderVisible,
    isValidClaim,
    product,
    spaTypes,
    temporaryObjectKey,
    warrantyStatusModal
});



// WEBPACK FOOTER //
// ./src/claim/spa/reducers/index.js